module.exports = function getResource(label, vars = []) {
    let resources = {
        userLabelText: `Vous devez être membre ${vars[0]} pour profiter de ce produit.`,
        signIn: 'Ouvrir une session',
        or: ' ou ',
        signUp: 'S’inscrire',
        learnMore: 'En savoir plus',
        downloadOpenApp: 'Pour l’acheter, téléchargez ou ouvrez l’appli Sephora.'
    };
    return resources[label];
};
